var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserPlus28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 24.2891C7.99996 21.1339 9.71029 18.2265 12.4682 16.6937L12.9781 16.4103C13.2956 16.2339 13.4544 16.1456 13.606 16.0672C16.8994 14.3635 20.8148 14.3635 24.1082 16.0672C24.2599 16.1456 24.4186 16.2339 24.7361 16.4103L25.246 16.6937C28.0039 18.2265 29.7142 21.1339 29.7142 24.2891C29.7142 25.8163 28.6528 27.1324 27.1426 27.3594C25.1388 27.6607 22.1506 28 18.8571 28C15.5636 28 12.5755 27.6607 10.5716 27.3594C9.06137 27.1324 7.99996 25.8163 7.99996 24.2891Z",
    fill: "url(#paint0_linear_12038_11810)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4285 7.99999C23.4285 10.5247 21.3818 12.5714 18.8571 12.5714C16.3324 12.5714 14.2857 10.5247 14.2857 7.99999C14.2857 5.47526 16.3324 3.42856 18.8571 3.42856C21.3818 3.42856 23.4285 5.47526 23.4285 7.99999Z",
    fill: "url(#paint1_linear_12038_11810)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85711 6.2857C6.22593 6.2857 5.71425 6.79738 5.71425 7.42856C5.71425 7.81066 5.60954 8.88191 5.5269 9.66789C5.47124 10.1973 5.05439 10.6141 4.52502 10.6698C3.73903 10.7524 2.66778 10.8571 2.28568 10.8571C1.6545 10.8571 1.14282 11.3688 1.14282 12C1.14282 12.6312 1.6545 13.1428 2.28568 13.1428C2.66778 13.1428 3.73903 13.2476 4.52502 13.3302C5.05439 13.3859 5.47124 13.8027 5.5269 14.3321C5.60954 15.1181 5.71425 16.1893 5.71425 16.5714C5.71425 17.2026 6.22593 17.7143 6.85711 17.7143C7.48829 17.7143 7.99996 17.2026 7.99996 16.5714C7.99996 16.1893 8.10467 15.1181 8.18731 14.3321C8.24297 13.8027 8.65983 13.3859 9.1892 13.3302C9.97519 13.2476 11.0464 13.1428 11.4285 13.1428C12.0597 13.1428 12.5714 12.6312 12.5714 12C12.5714 11.3688 12.0597 10.8571 11.4285 10.8571C11.0464 10.8571 9.97519 10.7524 9.1892 10.6698C8.65983 10.6141 8.24297 10.1973 8.18731 9.66789C8.10467 8.88191 7.99996 7.81066 7.99996 7.42856C7.99996 6.79738 7.48829 6.2857 6.85711 6.2857Z",
    fill: "url(#paint2_linear_12038_11810)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12038_11810",
    x1: 1.14282,
    y1: 3.42856,
    x2: 25.4374,
    y2: 31.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12038_11810",
    x1: 1.14282,
    y1: 3.42856,
    x2: 25.4374,
    y2: 31.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12038_11810",
    x1: 1.14282,
    y1: 3.42856,
    x2: 25.4374,
    y2: 31.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus28);
export default __webpack_public_path__ + "static/media/user_plus_28.34073611.svg";
export { ForwardRef as ReactComponent };